var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("牌照所属")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "350px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("牌照所属"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.customerIdFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("应用名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("应用名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("应用类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v("app")]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v("h5")]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v("pc")]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("小程序")))])], 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        return _vm.getSeachFun();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1), _c("a-form-item", [_vm.isAuth("home.applicationStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增应用")))]) : _vm._e()], 1)], 1), _c("standard-table", {
    staticClass: "marginT20",
    attrs: {
      tableData: _vm.tableData,
      tableHead: _vm.tableHead,
      loading: _vm.loading,
      bordered: "",
      pagination: _vm.pagination
    },
    on: {
      changeCurrent: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function ({
        index
      }) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "type",
      fn: function ({
        text
      }) {
        return [_vm._v(" " + _vm._s(text == 1 ? "app" : text == 2 ? "h5" : text == 3 ? "pc" : _vm.$t("小程序")) + " ")];
      }
    }, {
      key: "action",
      fn: function ({
        record
      }) {
        return [_vm.isAuth("home.applicationDetail") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleSee(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e(), _vm.isAuth("home.applicationEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()];
      }
    }])
  }), _vm.dialogVisible ? _c("application-model", {
    attrs: {
      currentRow: _vm.currentRow,
      dialogVisible: _vm.dialogVisible,
      tableData: _vm.tableData
    },
    on: {
      ok: _vm.handleOk,
      cancel: function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }) : _vm._e(), _vm.dialogVisible2 ? _c("see-application-model", {
    attrs: {
      currentRow: _vm.currentRow,
      dialogVisible: _vm.dialogVisible2,
      tableData: _vm.tableData
    },
    on: {
      ok: _vm.handleOk,
      cancel: function ($event) {
        _vm.dialogVisible2 = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };